import {useEffect, useRef} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@panda/css";

import {PriceIcon} from "@pg-design/icons-module";
import {MaxValueFieldControlled} from "@pg-design/rhf-components-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types/src/types/Currency";

import {getCurrency} from "../../../../utils/get_currency";
import {hitNegotiationInteraction, hitNegotiationView} from "../../../tracking/lead/hit_negotiation";
import {ILeadFormContext} from "../LeadFormBase";

interface INegotiationSlotProps {
    price: number;
    currency?: Currency;
    formMethods: ILeadFormContext<{negotiation: number}>["formMethods"];
}

export const LeadFormNegotiationSlot = ({price, currency, formMethods}: INegotiationSlotProps) => {
    const wasNegotiationInteractionHitRef = useRef(false);

    const negotiationValue = useWatch({
        control: formMethods.control,
        name: "negotiation"
    });

    useEffect(() => {
        hitNegotiationView();
    }, []);

    // Track negotiation slider interaction (only once per page load)
    useEffect(() => {
        if (!wasNegotiationInteractionHitRef.current && negotiationValue !== undefined && negotiationValue !== price) {
            wasNegotiationInteractionHitRef.current = true;
            hitNegotiationInteraction();
        }
    }, [negotiationValue, price]);

    return (
        <>
            <Text variant="body_copy_2" mb={3} className={css({display: "flex", alignItems: "center", gap: 1})}>
                <PriceIcon className={css({width: 24, height: 24})} /> Cena ofertowa:{" "}
                <Text as="span" variant="headline_6">
                    <Highlight>{priceFormat(price, {unit: getCurrency({currency})})}</Highlight>
                </Text>
            </Text>

            <MaxValueFieldControlled
                max={price}
                min={Math.ceil(price * 0.9)}
                step={1000}
                name="negotiation"
                defaultValue={price}
                useTriColorSlider
                rightElement={getCurrency({currency})}
                className={css({mb: 3})}
                labelContent="Twoja propozycja ceny"
            />
        </>
    );
};
